import Immutable from 'seamless-immutable';
import _ from 'lodash';

import RefData from 'ref-data';
import { assetRefService } from '../../common/Services';

/**
 * Integration Template
 * @typedef {object} Integration Template
 *
 * @property {string} classRef            RefData.Enum.CLASS.INTEGRATION.EMAIL
 * @property {object} config
 * @property {object} definition
 * @property {string} description
 * @property {string} eventType           RefData.Enum.EVENT.INTEGRATION.ENTRY, RefData.Enum.EVENT.INTEGRATION.PUBLISHENTRY
 * @property {string} help
 * @property {string} icon
 * @property {string} id
 * @property {string} name
 * @property {string} singleInstance
 * @property {string} status              RefData.Enum.STATUS.INTEGRATION.ACTIVE, RefData.Enum.STATUS.INTEGRATION.INACTIVE
 * @property {string} typeRef             RefData.Enum.TYPE.INTEGRATION.EMAIL
 *
 */

function create(integrationTemplate) {
  const result = _.clone(integrationTemplate);

  if (!_.isEmpty(result)) {
    result.typeRef = RefData.Model.hydrate(integrationTemplate.typeRef);
    result.classRef = RefData.Model.hydrate(integrationTemplate.classRef);
    result.eventType = RefData.Model.hydrate(integrationTemplate.eventType);
    result.status = RefData.Model.hydrate(integrationTemplate.status);
  }

  return Immutable(result, { prototype: model });
}

/**
 * Transforms a backend integrationTemplate object into a frontend IntegrationTemplate Model
 * @param {Object} integrationTemplate - backend formatted integration template
 * @returns {IntegrationTemplate}
 */
function deserialize(integrationTemplate) {
  const result = _.pick(integrationTemplate, _keys);

  return create(result);
}

const model = {
  get assetRef() {
    return assetRefService.buildAssetRef('weburl', 'image', '192x1505', App.globalContext.assetURL + this.icon);
  },
};

const _keys = [
  'classRef',
  'config',
  'definition',
  'description',
  'eventType',
  'help',
  'icon',
  'id',
  'name',
  'singleInstance',
  'status',
  'typeRef',
];

export default {
  create,
  deserialize,
};
